import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { IndexComponent } from "./index/index.component";
import { LoginComponent } from "./auth/login/login.component";
import { CveComponent } from "./cve/cve.component";
import { RecoveryPasswordComponent } from "./recovery-password/recovery-password.component";

const routes: Routes = [
  {
    path: "",
    component: IndexComponent,
  },
  {
    path: "login",
    component: LoginComponent,
  },
  {
    path: "descargas/cert",
    component: CveComponent,
  },
  {
    path: "solicitud-recuperar-contrasena",
    component: RecoveryPasswordComponent,
    data: {
      operation: "request recovery",
    },
  },
  {
    path: "recuperar-contrasena/:token",
    component: RecoveryPasswordComponent,
    data: {
      operation: "recovery",
    },
  },
  {
    path: "certificados",
    loadChildren: () =>
      import("./certificates/certificates.module").then(
        (m) => m.CertificatesModule
      ),
  },
  {
    path: "cambiar-password",
    loadChildren: () =>
      import("./change-password/change-password.module").then(
        (m) => m.ChangePasswordModule
      ),
  },
  {
    path: "coc",
    loadChildren: () => import("./coc/coc.module").then((m) => m.CocModule),
  },
  {
    path: "placa",
    loadChildren: () =>
      import("./placa/placa.module").then((m) => m.PlacaModule),
  },
  {
    path: "parámetros-personales",
    loadChildren: () =>
      import("./configuration-personal-params/personal-params.module").then(
        (m) => m.PersonalParamsModule
      ),
  },
  {
    path: "descarga-fichero-concesionario",
    loadChildren: () =>
      import(
        "./descarga-fichero-concesionario/descarga-fichero-concesionario.module"
      ).then((m) => m.DescargaFicheroConcesionarioModule),
  },
  {
    path: "exportar-historico-placa",
    loadChildren: () =>
      import("./export-historico-placa/export-historico-placa.module").then(
        (m) => m.ExportHistoricoPlacaModule
      ),
  },
  {
    path: "importar-datos-accesorios",
    loadChildren: () =>
      import("./import-datos-accesorios/import-datos-accesorios.module").then(
        (m) => m.ImportDatosAccesoriosModule
      ),
  },
  {
    path: "información",
    loadChildren: () => import("./info/info.module").then((m) => m.InfoModule),
  },
  {
    path: "concesionario",
    loadChildren: () =>
      import("./maintenance-concessionaire/concessionaire.module").then(
        (m) => m.ConcessionaireModule
      ),
  },
  {
    path: "datos-cdt",
    loadChildren: () =>
      import("./maintenance-data-cdt/data-cdt.module").then(
        (m) => m.DataCDTModule
      ),
  },
  {
    path: "maintenance-historico-bastidor",
    loadChildren: () =>
      import(
        "./maintenance-historico-bastidor/maintenance-historico-bastidor.module"
      ).then((m) => m.MaintenanceHistoricoBastidorModule),
  },
  {
    path: "reglas-buzon",
    loadChildren: () =>
      import("./maintenance-mailbox-rules/mailbox-rules.module").then(
        (m) => m.MailBoxModule
      ),
  },
  {
    path: "mastertablas",
    loadChildren: () =>
      import("./maintenance-mastertables/mastertables.module").then(
        (m) => m.MastertablesModule
      ),
  },
  {
    path: "formatos-impresion",
    loadChildren: () =>
      import("./maintenance-print-formats/print-formats.module").then(
        (m) => m.PrintFormatsModule
      ),
  },
  {
    path: "parametros-impresion",
    loadChildren: () =>
      import("./maintenance-prints-params/prints-params.module").then(
        (m) => m.PrintsParamsModule
      ),
  },
  {
    path: "reglas-impresion",
    loadChildren: () =>
      import("./maintenance-prints-rules/prints-rules.module").then(
        (m) => m.PrintsRulesModule
      ),
  },
  {
    path: "reformas",
    loadChildren: () =>
      import("./maintenance-reforms/reforms.module").then(
        (m) => m.ReformsModule
      ),
  },
  {
    path: "real-decreto",
    loadChildren: () =>
      import("./maintenance-royal-decree/royal-decree.module").then(
        (m) => m.RoyalDecreeModule
      ),
  },
  {
    path: "plantillas",
    loadChildren: () =>
      import("./maintenance-templates/templates.module").then(
        (m) => m.TemplatesModule
      ),
  },
  {
    path: "reglas-plantillas",
    loadChildren: () =>
      import("./maintenance-templates-rules/templates-rules.module").then(
        (m) => m.TemplatesRulesModule
      ),
  },
  {
    path: "maintenance-usuario",
    loadChildren: () =>
      import("./maintenance-user/maintenance-user.module").then(
        (m) => m.MaintenanceUserModule
      ),
  },
  {
    path: "consulta-patron-wltp",
    loadChildren: () =>
      import("./patrones-wltp/patrones-wltp.module").then(
        (m) => m.PatronesWltpModule
      ),
  },
  {
    path: "placa",
    loadChildren: () =>
      import("./placa/placa.module").then((m) => m.PlacaModule),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
